module.exports = __webpack_public_path__ + "static/sound-7efd0a4c82306c910076dc5fc14452d4.mp3";